import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ComponentContextService, CrudListComponent, DataListBase, GridInfo, ModelSchema, OrganizationService } from 'tnx-shared';
import { TreeNode } from 'tn-custom-primeng/api';

@Component({
    selector: 'app-organization',
    templateUrl: './organization.component.html',
    styleUrls: ['./organization.component.scss'],
    providers: [ComponentContextService],
})
export class OrganizationComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};


    rootTreeNode: TreeNode[] = [
        {
            label: '',
            data: '-1',
            expandedIcon: 'pi-folder',
            collapsedIcon: 'pi-folder-open',
            children: []
        }];

    isFirstLoad = true;
    rootFilter: any = {};

    selectedTreeNode: any;
    treeLoading = false;
    selectedNodeData: any;

    cols: any[] = [];

    currentOrgId: any;

    constructor(
        protected _injector: Injector,
        private _organizationService: OrganizationService
    ) {
        super(_injector);
        this.customGetData = true;
    }

    ngOnInit() {
        this.setting.baseService = this._organizationService;
        this.cols = [
            {
                field: 'ten',
                name: 'Tên phòng ban',
                fullName: 'Tên phòng ban',
                description: 'Tên phòng ban'
            },
            {
                field: 'code',
                name: 'Mã',
                fullName: 'Mã',
                description: 'Mã',
                width: '250px'
            },
            {
                field: 'description',
                name: 'Mô tả',
                fullName: 'Mô tả',
                description: 'Mô tả',
                width: '350px'
            },
        ];

        super.ngOnInit();
    }

    getTdClass() {
        var cl = 'flexcolumn defaulFlexColumn';
        return cl;
    }


    getDateType(data) {
        if (data == 0) {
            return 'Cấp lãnh đạo';
        }
        else if (data == 1) {
            return 'Cấp trung ương';
        }
        else if (data == 2) {
            return 'Cấp tỉnh/thành phố';
        }
    }

    getDataStatus(data) {
        if (data == 1) {

        }
        else if (data == 2) {

        }
        else {

        }
    }

    async getDataCustom(gridInfo?: GridInfo) {
        const rs = await this._organizationService.getOrganizationTreeTable();
        this.rootTreeNode = rs.data;
        this.rootTreeNode[0].expanded = true;
    }

}
